import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();


// WEBPACK FOOTER //
// ./src/container/History.js